import React, { useEffect, useState } from "react";
import "./AddCustomer.scss";

import { IoIosArrowBack, IoMdCloseCircle } from "react-icons/io";

import { useForm } from "react-hook-form";
import { CountryCodes } from "../../../constants/countryCodes";
import InputField from "../../../components/InputField/InputField";
import InputSelect from "../../../components/InputSelect/InputSelect";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton/CustomButton";
import ToggleSwitch from "../../../components/ToggleSwitch/ToggleSwitch";
import { useLocation, useNavigate } from "react-router-dom";

import ROUTES from "../../../constants/routes";
import { addCustomer, editCustomer } from "../../../api/customers";
import { toast } from "react-toastify";
import { updatePaymentCustomerDetails } from "../../../redux/features/cart-slice";
import { insertCustomerToSale } from "../../../api/sales";
import { fetchCustomerData } from "../../../redux/features/home-slice";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";
import { ElevatorSharp } from "@mui/icons-material";
import useUserIsAllowed from "../../../helpers/userAuthorized";
import {
  addNewCustomer,
  updateExistingCustomer,
} from "../../../redux/features/customers-slice";
import { isActuallyOnline } from "../../../helpers/network";
import ImageInput from "../../../components/ImageInput/ImageInput";

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const AddCustomer = ({
  isEdit,
  isPayment,
  isSale,
  sale,
  desktopView,
  setSelectedDesktopTag,
  setSelectedSale,
  selected,
  reload,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { currentViewPort, isReady } = useViewPortDetector();

  const salesDetails = isSale ? location.state?.salesDetails || sale : null;
  const userDetails = isSale ? location.state?.userData : null;
  const customerDataDetails = isSale ? location.state?.customerData : null;

  const { id: organization_id, countryCode } = useSelector(
    (state) => state.organizationReducer.value
  );
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({});

  const [image, setImage] = useState({
    src: null,
    file: null,
  });

  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    label: "",
    value: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [customerId, setCustomerId] = useState(null);

  const userIsAllowedToAddEditCustomer = useUserIsAllowed(
    "create_or_edit_customers"
  );

  useEffect(() => {
    if (!desktopView && currentViewPort === "desktop" && isReady) {
      navigate(ROUTES.customers.path);
    }
  }, [currentViewPort, isReady]);

  useEffect(() => {
    const selectOptions = [
      {
        label: "Code",
        value: "",
      },
    ];
    CountryCodes.forEach((item) => {
      selectOptions.push({
        label: `${item.flag}(${item.country_code})`,
        value: item.country_code,
      });
    });

    const orgDefault = selectOptions.find((el) => el?.value === countryCode);

    setSelectedOption(orgDefault || selectOptions[0]);
    setOptions(selectOptions);
  }, []);

  useEffect(() => {
    const editData =
      isEdit && desktopView ? selected : isEdit ? location.state?.editData : {};
    if (isEdit) {
      if (!editData?.id) {
        !desktopView && navigate(ROUTES.customers.path);
      } else {
        setCustomerId(editData?.id);
        const phonesData = `${editData?.phone_number}`.split(" ");
        reset({
          name: editData?.name,
          email: editData?.email,
          address_line: editData?.address_line,
          pay_later: editData?.pay_later,
          customer_number:
            phonesData?.length > 1 ? phonesData[1] : phonesData[0],
          customer_country_code: phonesData?.length > 1 ? phonesData[0] : "",
        });

        if (editData?.image) {
          setImage({
            file: null,
            src: `${IMAGE_URL}/${editData?.image}`,
          });
        }

        if (phonesData?.length > 1) {
          let selectedValue = options.find((el) => el?.value === phonesData[0]);
          if (selectedValue) {
            setSelectedOption(selectedValue);
          } else {
            setSelectedOption(options[0]);
          }
        } else {
          setSelectedOption(options[0]);
        }
      }
    } else {
      reset({
        name: "",
        email: "",
        address_line: "",
        pay_later: "",
        customer_number: "",
        customer_country_code: "",
      });

      setImage({
        file: null,
        src: null,
      });

      if (options.length > 0) {
        const orgDefault = options.find((el) => el?.value === countryCode);

        setSelectedOption(orgDefault || options[0]);
      } else {
        setSelectedOption({
          label: "",
          value: "",
        });
      }
    }
  }, [isEdit, location, options, selected]);

  const handleSubmitCustomer = async (data) => {
    setSubmitting(true);

    const customerData = new FormData();
    const phone_number = `${selectedOption?.value} ${data?.customer_number}`;
    if (image.file) {
      customerData.append("image", image.file);
    } else if (!image.src) {
      customerData.append("image_remove", true);
    }
    customerData.append("name", data?.name);
    if (data?.email) {
      customerData.append("email", data?.email);
    }
    customerData.append("phone_number", phone_number);
    if (data?.address_line) {
      customerData.append("address_line", data?.address_line);
    }
    customerData.append("pay_later", data?.pay_later);
    customerData.append("organization_id", organization_id);

    const isOnline = await isActuallyOnline();

    if (!isEdit) {
      if (isPayment && !isOnline) {
        const userData = {
          customer_name: data?.name,
          customer_number: data?.customer_number,
          customer_country_code: selectedOption?.value,
          customer_id: `new ${Date.now()}`,
          customer_address: data?.address_line || null,
          customer_allow_pay_later: data.pay_later,
          customer_email: data?.email || null,
          customer_credit_amount: 0,
        };
        dispatch(updatePaymentCustomerDetails(userData));
        toast.dismiss();
        toast.success("Customer added to sale's details.");
        navigate(ROUTES.payment.path);
      } else {
        addCustomer(customerData)
          .then((res) => {
            dispatch(fetchCustomerData({ organization_id: organization_id }));
            const user = res.data;
            dispatch(addNewCustomer({ customer: user }));

            if (isPayment) {
              const userData = {
                customer_name: data?.name,
                customer_number: data?.customer_number,
                customer_country_code: selectedOption?.value,
                customer_id: user?.id,
                customer_address: data?.address_line || null,
                customer_allow_pay_later: data.pay_later,
                customer_email: data?.email || null,
                customer_credit_amount: Number(user?.current_balance).toFixed(
                  2
                ),
              };
              dispatch(updatePaymentCustomerDetails(userData));
              toast.dismiss();
              toast.success("Customer added to sale's details.");
              navigate(ROUTES.payment.path);
            } else if (isSale) {
              const customerData = {
                customer_id: user?.id,
              };
              insertCustomerToSale(salesDetails?.id, customerData)
                .then((res) => {
                  toast.dismiss();
                  toast.success("Customer added to sales successfully.");
                  if (desktopView) {
                    setSelectedDesktopTag &&
                      setSelectedDesktopTag("Sales Details");
                    setSelectedSale &&
                      setSelectedSale({
                        ...sale,
                        customer: res.data?.sale?.customer || null,
                      });
                  } else {
                    navigate(ROUTES.salesDetails.path, {
                      state: {
                        item: res.data?.sale,
                        userData: userDetails,
                        customerData: customerDataDetails,
                      },
                    });
                  }
                })
                .catch((err) => {
                  toast.dismiss();
                  toast.error(
                    " Customer created but error while adding customer to sales!"
                  );
                  if (desktopView) {
                    setSelectedDesktopTag &&
                      setSelectedDesktopTag("Select Customer For Sale");
                  } else {
                    navigate(ROUTES.saleCustomer.path, {
                      state: {
                        salesDetails: res.data?.sale,
                        userData: userDetails,
                        customerData: customerDataDetails,
                      },
                    });
                  }
                });
            } else {
              toast.dismiss();
              toast.success("Customer Added Successfully.");
              navigate(ROUTES.customers.path);
            }
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss();
                toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                toast.dismiss();
                toast.error(`${err?.response?.data?.message}`);
              }
            } else {
              toast.dismiss();
              toast.success("Error while adding customer!");
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    } else {
      editCustomer(customerData, customerId)
        .then((res) => {
          toast.dismiss();
          toast.success("Customer Edited Successfully.");
          dispatch(updateExistingCustomer({ customer: res?.data?.customer }));
          !reload &&
            navigate(ROUTES.customers.path, {
              state: { customerSelected: res?.data?.customer || null },
            });
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss();
              toast.error(
                "You do not have sufficient permissions to perform this action. Please contact your administrator."
              );
            } else {
              toast.dismiss();
              toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss();
            toast.success("Error while editing customer!");
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  return (
    <div className="add-customer">
      <form
        onSubmit={handleSubmit(handleSubmitCustomer)}
        className="container-wrapper"
      >
        <div className="input-container">
          <ImageInput
            image={image}
            setImage={setImage}
            label={image.src ? "No Image" : "Customer's Image"}
            featureAvailable={true}
            isAllowed={userIsAllowedToAddEditCustomer}
          />

          <InputField
            name={"name"}
            type={"text"}
            label={"Customer Name"}
            required={true}
            register={register}
            inputErrors={errors}
            watch={watch}
            disabled={!userIsAllowedToAddEditCustomer}
          />

          <div className="select-and-input">
            <InputField
              name={"customer_number"}
              type={"text"}
              label={"Phone Number"}
              required={true}
              register={register}
              inputErrors={errors}
              watch={watch}
              constraints={{
                maxLength: {
                  value: 15,
                  message: "Phone number cannot exceed 15 digits",
                },
                pattern: {
                  value: /^[0-9]+$/,
                  message: "Only numbers are allowed",
                },
              }}
              disabled={!userIsAllowedToAddEditCustomer}
            />
            <div className="select-wrapper">
              <InputSelect
                options={options}
                value={selectedOption}
                register={register}
                required={false}
                name="customer_country_code"
                handleChange={(opt) => {
                  setSelectedOption(opt);
                }}
                reset={reset}
                label={""}
                inputErrors={errors}
                disabled={!userIsAllowedToAddEditCustomer}
              />
            </div>
          </div>

          <InputField
            name={"email"}
            type={"email"}
            label={"Email"}
            required={false}
            register={register}
            inputErrors={errors}
            watch={watch}
            disabled={!userIsAllowedToAddEditCustomer}
          />

          <InputField
            name={"address_line"}
            type={"text"}
            label={"Address Line(Optional)"}
            required={false}
            register={register}
            inputErrors={errors}
            watch={watch}
            disabled={!userIsAllowedToAddEditCustomer}
          />

          <ToggleSwitch
            name={"pay_later"}
            label={"Allow customer to pay later"}
            register={register}
            required={false}
            showSVG={false}
            disabled={!userIsAllowedToAddEditCustomer}
          />
        </div>

        <div className="buttons">
          <CustomButton
            name={isEdit ? "Update Customer" : "Add Customer"}
            color={"primary"}
            type={"submit"}
            handleSubmit={() => {}}
            disabled={submitting || !userIsAllowedToAddEditCustomer}
            bigButton={true}
            loader={submitting}
          />
        </div>
      </form>

      {(isSale || isEdit) && (
        <div
          className="navigation-back-button"
          onClick={() => {
            if (isEdit) {
              navigate(ROUTES.customers.path, {
                state: { customerSelected: location.state?.editData || null },
              });
            } else {
              navigate(ROUTES.saleCustomer.path, {
                state: {
                  salesDetails: salesDetails,
                  userData: userDetails,
                  customerData: customerDataDetails,
                },
              });
            }
          }}
        >
          <IoIosArrowBack />
        </div>
      )}
    </div>
  );
};

export default AddCustomer;
